import React, { Fragment, FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Desktop } from 'Shared/components/Responsive'
import { PageSubHeader } from 'Stories/PageSubHeader/PageSubHeader.stories'
import { BlockOfText } from 'Stories/BlockOfText/BlockOfText.stories'
import ToggleSwitchAntd from 'Containers/ui/ToggleSwitchAntd'

import { PlatformsWrapperProps } from './PlatformsWrapperProps'

import {
  PlatformsWrapperStyle,
  PlatformContainer,
  WrapperForToggleSwitchAntd,
  Title,
  Platform,
  PlatformIcon,
  PageSubHeaderWrapper,
  AddedSuccessfully,
} from './styles'

const PlatformsWrapper: FunctionComponent<PlatformsWrapperProps> = ({
  icon,
  title,
  text,
  track,
  modal,
  children,
}) => {
  const [checked, setChecked] = useState<boolean>(false)
  const toggle = () => setChecked(!checked)

  const { t } = useTranslation()

  return (
    <Fragment>
      <PlatformsWrapperStyle>
        <PlatformContainer>
          <WrapperForToggleSwitchAntd>
            <ToggleSwitchAntd checked={checked} onChange={toggle} />
          </WrapperForToggleSwitchAntd>

          <Platform>
            <Title>
              <PlatformIcon>{icon}</PlatformIcon>
              <PageSubHeaderWrapper>
                <PageSubHeader content={title} />
              </PageSubHeaderWrapper>
            </Title>

            {!checked && <BlockOfText content={text} />}
            {checked && modal}

            <Desktop>
              {checked && track && (
                <AddedSuccessfully>
                  {t('createCampaignPage.trackIsAddedSuccessfully')}
                </AddedSuccessfully>
              )}
            </Desktop>
          </Platform>
        </PlatformContainer>
      </PlatformsWrapperStyle>

      {checked && track && children}
    </Fragment>
  )
}

export default PlatformsWrapper
